import React, { useEffect, useState, useRef } from "react";
import {
    Col,
    Container,
    Row,
    Form,
    Button,
    Spinner,
    Table,
    Tab,
    Nav,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import Pagination from "../Common/Pagination";
import * as XLSX from "xlsx";

const NewContractor = () => {
    const userState = useSelector(state => state?.loginData?.userData);
    const financialYear = useSelector((state) => state.activeData.financialYear);
    const activeKey = useSelector((state) => state.activeData?.activeNumberKey?.activeKey);
    const navigate = useNavigate();

    const [contractor, setContractor] = useState();
    const [lessThanTen, setLessThanTen] = useState();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startDateErr, setStartDateErr] = useState("");
    const [endDateErr, setEndDateErr] = useState("");
    const [zoneList, setZoneList] = useState([]);
    const [zoneB, setZoneB] = useState("");
    const [role, setRole] = useState("");
    const [zoneErr, setZoneErr] = useState(false);
    const [loader, setLoader] = useState(false);
    const [lessloader, setLessLoader] = useState(false);
    const [excelLoader, setExcelLoader] = useState(false);

    const [searchMobile, setSearchMobile] = useState("");
    const [searchMobErr, setSearchMobErr] = useState(false);

    const [pageNo, setPageNo] = useState(1);
    const [docPerPage, setDocPerPage] = useState(50);
    const [noOfPages, setNoOfPages] = useState(0);

    const [key, setKey] = useState("allData");

    const requestRef = useRef(0);
    const prevYearRef = useRef(financialYear);

    const handlePageChange = (pageNumber) => {
        setPageNo(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setPageNo(1);
        setDocPerPage(docsPageProp);
    };

    useEffect(() => {
        getZoneList();
        // Zonal officer ka zone set karo
        if (userState?.usertype_keyname?.includes("zonalofficer")) {
            setZoneB(userState?.zonename);
        }
    }, []);

    // Financial year change hone par reset + fresh call
    useEffect(() => {
        const isYearChanged = prevYearRef.current !== financialYear;

        if (isYearChanged) {
            // Saare filters reset
            setSearchMobile("");
            setStartDate("");
            setEndDate("");
            setRole("");
            setPageNo(1);
            setContractor();
            setLessThanTen();

            // Zonal officer ka zone reset nahi karna
            if (!userState?.usertype_keyname?.includes("zonalofficer")) {
                setZoneB("");
            }

            prevYearRef.current = financialYear;
        }

        getContarctorList(
            isYearChanged ? "" : searchMobile,
            isYearChanged ? "" : startDate,
            isYearChanged ? "" : endDate,
            isYearChanged ? "" : zoneB,
            isYearChanged ? "" : role,
            isYearChanged ? 1 : pageNo
        );

    }, [docPerPage, pageNo, financialYear]);

    // get List API
    const getContarctorList = async (
        mobile = searchMobile,
        sDate = startDate,
        eDate = endDate,
        zone = zoneB,
        rl = role,
        pNo = pageNo
    ) => {
        const requestId = ++requestRef.current;
        setLoader(true);
        try {
            const res = await fetch(
                process.env.REACT_APP_BASE_URL + "/billDistribution/mahaPalikaUserReport",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        role: rl,
                        visitingPersonContactNo: mobile,
                        fromDate: sDate,
                        toDate: eDate,
                        documentsPerPage: docPerPage,
                        page: pNo,
                        financialYear: financialYear,
                        zonename: userState?.usertype_keyname?.includes("zonalofficer")
                            ? userState?.zonename
                            : userState?.usertype_keyname?.includes("admin")
                                ? zone
                                : "",
                        // gatkey: userState?.usertype_keyname?.includes("gatlipik") ? userState.gatkey : "",
                        gatkey:
                            userState?.usertype_keyname?.includes("gatlipik") ||
                                userState?.usertype_keyname?.includes("supervisor")
                                ? userState.gatkey
                                : "",
                        ...(userState?.usertype_keyname?.includes("supervisor") ||
                            userState?.usertype_keyname?.includes("mavim") ||
                            userState?.usertype_keyname?.includes("sakshama")
                            ? {
                                zonekeyArray:
                                    userState?.organizationZone?.map(z => String(z.zonekey)) || [],
                            }
                            : {})
                    }),
                }
            );
            const response = await res.json();

            if (requestId !== requestRef.current) return;
            if (response.status === 200) {
                setContractor(response);
                setNoOfPages(response.noOfPages);
            } else if (response.status === 404) {
                setContractor({ data: [] });
            } else {
                setContractor();
            }
        } catch (error) {
            if (requestId === requestRef.current) {
                setContractor();
            }
        } finally {
            if (requestId === requestRef.current) {
                setLoader(false);
            }
        }
    };

    const getLessThanTenPercentageList = async () => {
        setLessLoader(true);
        await fetch(
            process.env.REACT_APP_BASE_URL + "/billDistribution/toggleContractorReport",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    visitingPersonContactNo: searchMobile,
                    zonekey: zoneB,
                    fromDate: startDate,
                    toDate: endDate,
                    financialYear: financialYear,
                    ...(userState?.usertype_keyname?.includes("zonalofficer") && {
                        zonekey: userState?.zonekey
                    })
                }),
            }
        )
            .then((res) => res.json())
            .then((response) => {
                if (response.status === 200) {
                    setLessThanTen(response);
                    setLessLoader(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLessLoader(false);
            });
    };

    const getZoneList = async () => {
        await fetch(process.env.REACT_APP_BASE_URL + "/zoneData/getZoneData", {
            method: "GET",
        })
            .then((res) => res.json())
            .then((response) => {
                setZoneList(response.data);
            })
            .catch((err) => {
                console.log("Error While Fetching Zone List", err);
            });
    };

    const searchByStartEndValidate = () => {
        let isValid = true;
        if (!startDate) {
            isValid = false;
            setStartDateErr(true);
        } else if (!endDate) {
            isValid = false;
            setEndDateErr(true);
        }
        return isValid;
    };

    const searchByDate = () => {
        if (searchByStartEndValidate()) {
            key === "lessThanTen" ? getLessThanTenPercentageList() : getContarctorList();
        }
    };

    const searchByMobile = () => {
        if (searchMobile.length === 10) {
            key === "lessThanTen" ? getLessThanTenPercentageList() : getContarctorList();
        } else {
            toast.error("Please Enter Valid Mobile Number.");
        }
    };

    const searchByZone = () => {
        if (zoneB.length > 0) {
            key === "lessThanTen" ? getLessThanTenPercentageList() : getContarctorList();
        } else {
            toast.error("Please Select Zone first.");
        }
    };

    const searchByRole = () => {
        getContarctorList();
    };


    const exportToExcel = async () => {
        const wb = XLSX.utils.book_new();
        let wsData = [];
        let sheetName = "";

        if (key === 'allData') {
            try {
                setExcelLoader(true);

                // Use the same filters that are currently applied
                const requestBody = {
                    role: role,
                    visitingPersonContactNo: searchMobile,
                    fromDate: startDate,
                    toDate: endDate,
                    documentsPerPage: 100000, // Get all data at once
                    page: 1,
                    financialYear: financialYear,
                    zonename: userState?.usertype_keyname?.includes("zonalofficer")
                        ? userState?.zonename
                        : userState?.usertype_keyname?.includes("admin")
                            ? zoneB
                            : "",
                    gatkey: userState?.usertype_keyname?.includes("gatlipik") ||
                        userState?.usertype_keyname?.includes("supervisor")
                        ? userState.gatkey
                        : "",
                    ...(userState?.usertype_keyname?.includes("supervisor") ||
                        userState?.usertype_keyname?.includes("mavim") ||
                        userState?.usertype_keyname?.includes("sakshama")
                        ? {
                            zonekeyArray: userState?.organizationZone?.map(z => String(z.zonekey)) || [],
                        }
                        : {})
                };

                // Add zonekey for zonal officer
                if (userState?.usertype_keyname?.includes("zonalofficer")) {
                    requestBody.zonekey = userState?.zonekey;
                }
                // Add zonekey for admin when zone is selected
                if (userState?.usertype_keyname?.includes("admin") && zoneB) {
                    const selectedZone = zoneList.find(zone => zone.zonename === zoneB);
                    if (selectedZone) {
                        requestBody.zonekey = selectedZone.zonekey;
                    }
                }

                const response = await fetch(
                    process.env.REACT_APP_BASE_URL + "/billDistribution/mahaPalikaUserReport",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestBody),
                    }
                );

                const apiData = await response.json();

                if (apiData.status !== 200) {
                    toast.error("Failed to fetch data for export");
                    setExcelLoader(false);
                    return;
                }

                // Create headers based on the current tab
                if (key === 'allData') {
                    wsData = [
                        ["Sr No.", "Palika User", "Role", "Mobile", "Notice Count", "Mobile Verified Count",
                            "Property Found Count", "Property Not Found Count", "Total Count", "Mobile Updated (%)"]
                    ];

                    apiData?.data?.forEach((row, index) => {
                        wsData.push([
                            index + 1,
                            row?.name || "-",
                            row?.role || "-",
                            row?.mobile || "-",
                            row?.noticeCount || 0,
                            row?.mobileVerifiedCount || 0,
                            row?.propertyFoundCount || 0,
                            row?.propertyNotFoundCount || 0,
                            row?.totalCount || 0,
                            row?.percentage || 0,
                        ]);
                    });

                    // Add summary row
                    wsData.push([
                        "Total of the Counts", "", "", "",
                        apiData?.totalNoticeCount || 0,
                        apiData?.totalMobileVerifiedCount || 0,
                        apiData?.totalPropertyFoundCount || 0,
                        apiData?.totalPropertyNotFoundCount || 0,
                        apiData?.totalVisits || 0,
                        "",
                    ]);

                    sheetName = "Palika_Wise_All_Data";
                } else if (key === 'lessThanTen') {
                    // For less than 10% tab
                    wsData = [
                        ["Sr No.", "Name", "Mobile", "Notice Count", "Mobile Verified Count",
                            "Property Found Count", "Property Not Found Count", "Total Count", "Mobile Updated (%)"]
                    ];

                    apiData?.data?.forEach((row, index) => {
                        wsData.push([
                            index + 1,
                            row?.name || "-",
                            row?.mobile || "-",
                            row?.noticeCount || 0,
                            row?.mobileVerifiedCount || 0,
                            row?.propertyFoundCount || 0,
                            row?.propertyNotFoundCount || 0,
                            row?.totalCount || 0,
                            row?.percentage || 0,
                        ]);
                    });

                    wsData.push([
                        "Total of the Counts", "", "",
                        apiData?.totalNoticeCount || 0,
                        apiData?.totalMobileVerifiedCount || 0,
                        apiData?.totalPropertyFoundCount || 0,
                        apiData?.totalPropertyNotFoundCount || 0,
                        apiData?.totalVisits || 0,
                    ]);

                    sheetName = "Less_Than_10_Percentage_Data";
                }

                const ws = XLSX.utils.aoa_to_sheet(wsData);

                // Auto-size columns
                const colWidths = [];
                for (let i = 0; i < wsData[0]?.length; i++) {
                    let maxWidth = 10;
                    for (let j = 0; j < wsData.length; j++) {
                        const cellValue = wsData[j][i]?.toString() || "";
                        maxWidth = Math.max(maxWidth, cellValue.length);
                    }
                    colWidths.push({ wch: Math.min(maxWidth + 2, 30) });
                }
                ws['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(wb, ws, sheetName);

                // Add filter information sheet
                const filterInfo = [
                    ["Export Filters Applied:"],
                    ["Filter", "Value"],
                    ["Financial Year", financialYear || "All"],
                    ["Role", role || "All"],
                    ["Mobile Number", searchMobile || "All"],
                    ["Start Date", startDate || "All"],
                    ["End Date", endDate || "All"],
                    ["Zone", zoneB || "All"],
                    ["Export Date", moment().format("YYYY-MM-DD HH:mm:ss")],
                    ["Exported By", userState?.username || "Unknown"]
                ];

                const wsFilters = XLSX.utils.aoa_to_sheet(filterInfo);
                XLSX.utils.book_append_sheet(wb, wsFilters, "Export_Info");

                const fileName = `${sheetName}_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
                XLSX.writeFile(wb, fileName);

                toast.success("Excel exported successfully!");

            } catch (error) {
                console.error("Export API call failed:", error);
                toast.error("Failed to export Excel. Please try again.");
            } finally {
                setExcelLoader(false);
            }
        } else if (key === 'lessThanTen') {
            // For lessThanTen tab export
            try {
                setExcelLoader(true);

                const requestBody = {
                    visitingPersonContactNo: searchMobile,
                    zonekey: zoneB,
                    fromDate: startDate,
                    toDate: endDate,
                    financialYear: financialYear,
                    ...(userState?.usertype_keyname?.includes("zonalofficer") && {
                        zonekey: userState?.zonekey
                    })
                };

                const response = await fetch(
                    process.env.REACT_APP_BASE_URL + "/billDistribution/toggleContractorReport",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestBody),
                    }
                );

                const apiData = await response.json();

                if (apiData.status !== 200) {
                    toast.error("Failed to fetch data for export");
                    setExcelLoader(false);
                    return;
                }

                wsData = [
                    ["Sr No.", "Name", "Mobile", "Notice Count", "Mobile Verified Count",
                        "Property Found Count", "Property Not Found Count", "Total Count", "Mobile Updated (%)"]
                ];

                apiData?.data?.forEach((row, index) => {
                    wsData.push([
                        index + 1,
                        row?.name || "-",
                        row?.mobile || "-",
                        row?.noticeCount || 0,
                        row?.mobileVerifiedCount || 0,
                        row?.propertyFoundCount || 0,
                        row?.propertyNotFoundCount || 0,
                        row?.totalCount || 0,
                        row?.percentage || 0,
                    ]);
                });

                wsData.push([
                    "Total of the Counts", "", "",
                    apiData?.totalNoticeCount || 0,
                    apiData?.totalMobileVerifiedCount || 0,
                    apiData?.totalPropertyFoundCount || 0,
                    apiData?.totalPropertyNotFoundCount || 0,
                    apiData?.totalVisits || 0,
                ]);

                sheetName = "Less_Than_10_Percentage_Data";

                const ws = XLSX.utils.aoa_to_sheet(wsData);

                // Auto-size columns
                const colWidths = [];
                for (let i = 0; i < wsData[0]?.length; i++) {
                    let maxWidth = 10;
                    for (let j = 0; j < wsData.length; j++) {
                        const cellValue = wsData[j][i]?.toString() || "";
                        maxWidth = Math.max(maxWidth, cellValue.length);
                    }
                    colWidths.push({ wch: Math.min(maxWidth + 2, 30) });
                }
                ws['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(wb, ws, sheetName);

                const fileName = `${sheetName}_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
                XLSX.writeFile(wb, fileName);

                toast.success("Excel exported successfully!");

            } catch (error) {
                console.error("Export API call failed:", error);
                toast.error("Failed to export Excel. Please try again.");
            } finally {
                setExcelLoader(false);
            }
        }
    };
    return (
        <div className="visitReport">
            <ToastContainer />
            <Container>
                <Row className="justify-content-center">
                    <Col md={4} className="searchCard m-2">
                        <div className="label mb-2 mx-auto">
                            <p>Search by mobile</p>
                        </div>
                        <div className="d-flex mt-1">
                            <Form.Control
                                className="me-3"
                                placeholder="Enter mobile number"
                                value={searchMobile}
                                name="contactNo"
                                onChange={(e) => {
                                    if (
                                        !e.target.value.match(/[A-Za-z+@#$&%!~=*./\s/g/\-/?<>,"/]/) &&
                                        e.target.value.length <= 10
                                    ) {
                                        setSearchMobile(e.target.value);
                                    }
                                    e.target.value.length > 0 ? setSearchMobErr(false) : setSearchMobErr(true);
                                }}
                            />
                            <Button className="btn-submit" onClick={searchByMobile}>
                                <Icon.Search className="me-2" size={14} />
                                Search
                            </Button>
                        </div>
                        {searchMobErr ? <p>Please enter valid mobile number</p> : null}
                    </Col>

                    {userState?.usertype_keyname?.includes("admin") &&
                        <Col md={4} className="searchCard m-2">
                            <div className="label mb-2 mx-auto">
                                <p>Search by Zone</p>
                            </div>
                            <div className="d-flex mt-1">
                                <Form.Select
                                    className="me-2"
                                    value={zoneB}
                                    onChange={(e) => setZoneB(e.target.value)}
                                >
                                    <option value="">Select Zone</option>
                                    {zoneList !== undefined && zoneList.length > 0 ? (
                                        zoneList.map((row) => (
                                            <option key={row.zonekey} value={row.zonename}>
                                                {row.zonename + "-" + row.zoneno}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="">No Data Found</option>
                                    )}
                                </Form.Select>
                                <Button className="btn-submit" onClick={searchByZone}>
                                    <Icon.Search className="me-2" size={14} />
                                    Search
                                </Button>
                            </div>
                            {zoneErr ? <p>Please select any zone</p> : null}
                        </Col>
                    }

                    <Col md={6} className="searchCard justify-content-center m-2">
                        <div className="label mb-2 mx-auto">
                            <p>Search by Start Date/End Date</p>
                        </div>
                        <Row className="d-flex justify-content-center">
                            <Col md={4} className="mb-3 mb-md-0">
                                <Form.Label>Search by Start Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                        setStartDate(moment(e.target.value).format("YYYY-MM-DD"));
                                        setEndDate("");
                                        e.target.value.length > 0 && setStartDateErr(false);
                                    }}
                                />
                                {startDateErr ? <p className="errMsg">Please select Start Date</p> : ""}
                            </Col>

                            <Col md={4} className="mb-3 mb-md-0">
                                <Form.Label>Search by End Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    min={startDate ? startDate : ""}
                                    max={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => {
                                        setEndDate(moment(e.target.value).format("YYYY-MM-DD"));
                                        e.target.value.length > 0 && setEndDateErr(false);
                                    }}
                                />
                                {endDateErr ? <p className="errMsg">Please select End Date</p> : ""}
                            </Col>

                            <Col md={2} className="mt-4">
                                <Button className="btn btn-submit" onClick={searchByDate}>
                                    <Icon.Search className="me-2" size={14} />
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Col>

                    {userState?.usertype_keyname?.includes("admin") &&
                        <Col md={4} className="searchCard m-2 d-flex flex-column">
                            <div className="label mb-2 mx-auto">
                                <p>Search by Role</p>
                            </div>
                            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                                <Form.Select
                                    className="me-2"
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                >
                                    <option value="">Select Role</option>
                                    <option value="Zonal Officer">Zonal Officer</option>
                                    <option value="Gat Lipik">Gat Lipik</option>
                                </Form.Select>
                                <Button className="btn-submit" onClick={searchByRole}>
                                    <Icon.Search className="me-2" size={14} />
                                    Search
                                </Button>
                            </div>
                            {zoneErr ? <p>Please select any Role</p> : null}
                        </Col>
                    }

                    {userState?.usertype_keyname?.includes("zonalofficer") &&
                        <Col md={4} className="searchCard m-2">
                            <div className="label mb-2 mx-auto">
                                <p>Search by Role</p>
                            </div>
                            <div className="d-flex mt-1">
                                <Form.Select
                                    className="me-2"
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                >
                                    <option value="">Select Role</option>
                                    <option value="Zonal Officer">Self</option>
                                    <option value="Gat Lipik">Gat Lipik</option>
                                </Form.Select>
                                <Button className="btn-submit" onClick={searchByZone}>
                                    <Icon.Search className="me-2" size={14} />
                                    Search
                                </Button>
                            </div>
                            {zoneErr ? <p>Please select any Role</p> : null}
                        </Col>
                    }
                </Row>

                <Row className="justify-content-center mt-2">
                    <Col className="tab">
                        <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                            <Row className="d-flex justify-content-between align-items-center">
                                <Col md={2}>
                                    <Button
                                        className="btn btn-submit"
                                        onClick={exportToExcel}
                                        disabled={excelLoader}
                                    >
                                        {excelLoader ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Exporting...
                                            </>
                                        ) : (
                                            <>
                                                <Icon.CloudArrowDownFill className="me-2" size={20} />
                                                Excel Export
                                            </>
                                        )}
                                    </Button>
                                </Col>
                                <Col md={8} className="p-0">
                                    <Nav variant="pills" className="flex-row"></Nav>
                                </Col>
                                <Col className="mt-4">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="lessThanTen">
                                            <div className="container tbl-container p-0 mb-5">
                                                <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
                                                    <Table responsive="lg" hover>
                                                        <thead>
                                                            <th>Sr No.</th>
                                                            <th>Name</th>
                                                            <th>Mobile</th>
                                                            <th>Notice Count</th>
                                                            <th>Mobile Verified Count</th>
                                                            <th>Property Found Count</th>
                                                            <th>Property Not Found Count</th>
                                                            <th>Total Count</th>
                                                            <th>Mobile Updated (%)</th>
                                                            <th>Action</th>
                                                        </thead>
                                                        <tbody>
                                                            {lessloader ? (
                                                                <tr>
                                                                    <td colSpan="10" style={{ textAlign: 'center' }}>
                                                                        <Spinner />
                                                                    </td>
                                                                </tr>
                                                            ) : lessThanTen && lessThanTen?.data?.length > 0 ? (
                                                                lessThanTen?.data?.map((row, index) => (
                                                                    <tr key={index} className={!row.isValid ? "red-row" : ""}>
                                                                        <td>{pageNo !== 1 ? index + 1 + docPerPage * (pageNo - 1) : index + 1}</td>
                                                                        <td>{row?.name ? row?.name : "-"}</td>
                                                                        <td>{row?.mobile ? row?.mobile : "-"}</td>
                                                                        <td>{row?.noticeCount ? row?.noticeCount : 0}</td>
                                                                        <td>{row?.mobileVerifiedCount ? row?.mobileVerifiedCount : 0}</td>
                                                                        <td>{row?.propertyFoundCount ? row?.propertyFoundCount : 0}</td>
                                                                        <td>{row?.propertyNotFoundCount ? row?.propertyNotFoundCount : 0}</td>
                                                                        <td>{row?.totalCount ? row?.totalCount : 0}</td>
                                                                        <td>{row?.percentage ? row?.percentage : 0}</td>
                                                                        <td className="text-center bg-white text-black">
                                                                            <Icon.Eye
                                                                                style={{ cursor: "pointer" }}
                                                                                size={25}
                                                                                onClick={() => {
                                                                                    localStorage.setItem('contractor', JSON.stringify(row));
                                                                                    navigate("/dashboard/view-contractor-report", { state: { contractor: row } });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="10" style={{ textAlign: 'center' }}>No Data Found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                        <tfoot>
                                                            {lessThanTen !== undefined && lessThanTen?.data?.length > 0 ? (
                                                                <tr className="sum-row">
                                                                    <td colSpan="3"><strong className="m-2">Total of the Counts :-</strong></td>
                                                                    <td><strong>{lessThanTen.totalNoticeCount ?? "0"}</strong></td>
                                                                    <td><strong>{lessThanTen.totalMobileVerifiedCount ?? "0"}</strong></td>
                                                                    <td><strong>{lessThanTen.totalPropertyFoundCount ?? "0"}</strong></td>
                                                                    <td><strong>{lessThanTen.totalPropertyNotFoundCount ?? "0"}</strong></td>
                                                                    <td><strong>{lessThanTen.totalVisits ?? "0"}</strong></td>
                                                                    <td></td>
                                                                </tr>
                                                            ) : null}
                                                        </tfoot>
                                                    </Table>
                                                </div>
                                                <Row>
                                                    <Col md={4} className="d-flex align-items-center mt-3">
                                                        <h6 className="text-start mb-0">
                                                            <Icon.People className="me-2" />
                                                            Total - <strong>{lessThanTen?.count}</strong>
                                                        </h6>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="allData">
                                            <div className="container tbl-container p-0">
                                                <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
                                                    <Table responsive="lg" hover>
                                                        <thead>
                                                            <th>Sr No.</th>
                                                            <th>Palika User</th>
                                                            <th>Role</th>
                                                            <th>Mobile</th>
                                                            <th>Notice Count</th>
                                                            <th>Mobile Verified Count</th>
                                                            <th>Property Found Count</th>
                                                            <th>Property Not Found Count</th>
                                                            <th>Total Count</th>
                                                            <th>Mobile Updated (%)</th>
                                                            <th>Action</th>
                                                        </thead>
                                                        <tbody>
                                                            {loader ? (
                                                                <tr>
                                                                    <td colSpan="11" style={{ textAlign: 'center' }}>
                                                                        <Spinner />
                                                                    </td>
                                                                </tr>
                                                            ) : contractor && contractor?.data.length > 0 ? (
                                                                contractor?.data?.map((row, index) => (
                                                                    <tr key={index} className={!row.isValid ? "red-row" : ""}>
                                                                        <td>{pageNo !== 1 ? index + 1 + docPerPage * (pageNo - 1) : index + 1}</td>
                                                                        <td>{row?.name ? row?.name : "-"}</td>
                                                                        <td>{row?.role}</td>
                                                                        <td>{row?.mobile ? row?.mobile : "-"}</td>
                                                                        <td>{row?.noticeCount ? row?.noticeCount : 0}</td>
                                                                        <td>{row?.mobileVerifiedCount ? row?.mobileVerifiedCount : 0}</td>
                                                                        <td>{row?.propertyFoundCount ? row?.propertyFoundCount : 0}</td>
                                                                        <td>{row?.propertyNotFoundCount ? row?.propertyNotFoundCount : 0}</td>
                                                                        <td>{row?.totalCount ? row?.totalCount : 0}</td>
                                                                        <td>{row?.percentage ? row?.percentage : 0}</td>
                                                                        <td className="text-center bg-white text-black">
                                                                            <Icon.Eye
                                                                                style={{ cursor: "pointer" }}
                                                                                size={25}
                                                                                onClick={() => {
                                                                                    localStorage.setItem('contractor', JSON.stringify(row));
                                                                                    navigate("/dashboard/view-contractor-report", {
                                                                                        state: { contractor: row, zoneSearched: zoneB, startDate, endDate }
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="11" style={{ textAlign: 'center' }}>No Data Found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                        <tfoot>
                                                            {contractor !== undefined && contractor.data.length > 0 ? (
                                                                <tr className="sum-row">
                                                                    <td colSpan="4"><strong className="m-2">Total of the Counts :-</strong></td>
                                                                    <td><strong>{contractor.totalNoticeCount ?? "0"}</strong></td>
                                                                    <td><strong>{contractor.totalMobileVerifiedCount ?? "0"}</strong></td>
                                                                    <td><strong>{contractor.totalPropertyFoundCount ?? "0"}</strong></td>
                                                                    <td><strong>{contractor.totalPropertyNotFoundCount ?? "0"}</strong></td>
                                                                    <td><strong>{contractor.totalVisits ?? "0"}</strong></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                </tr>
                                                            ) : null}
                                                        </tfoot>
                                                    </Table>
                                                </div>
                                                <Row>
                                                    <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                                                        <h6 className="text-start mb-0">
                                                            <Icon.People className="me-2" />
                                                            Total - <strong>{contractor?.count}</strong>
                                                        </h6>
                                                    </Col>
                                                    <Col md={8} className="d-flex justify-content-end">
                                                        <Pagination
                                                            currentPage={pageNo}
                                                            totalPages={noOfPages}
                                                            onPageChange={handlePageChange}
                                                            onDocsPerPage={handleDocsPerPage}
                                                            docsPerPage={docPerPage}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default NewContractor;